import { NoteType } from './note-type';
import { Permission } from './permission';

export class Role {
	public roleId: string;
	public level: number;
	public name: string;
	public description: string;
	public isActive: boolean;

	public noteTypes: NoteType[];
	public permissions: Permission[];

	constructor(role?: Role) {
		Object.assign(this, role);

		if (this.permissions) {
			this.permissions = this.permissions.map(p => new Permission(p));
		}
	}
}
